import csi from "csi/main";
import { useStore } from "csi/state/hooks";
import { setCSSConstants, setCSSVariables } from "csi/utility/htmlUtility";
import xml from "csi/xml";
import { LocaleContext } from "designSystem/locale";
import { getSkinVariables } from "designSystem/styles/color";
import Theme from "designSystem/theme";
import { observer } from "mobx-react-lite";
import React from "react";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import ReactPortals from "./ReactPortals/ReactPortals";
import localeProvider from "./localeProvider";

const ReactRoot = observer(() => {
	const { sessionStore: { skinTheme } } = useStore();
	const skin = xml.enumGetText(skinTheme);

	// TODO: Implement StrictMode once MUI 5 is out - https://github.com/mui-org/material-ui/issues/13394
	// currently issue with use of findDOMNode

	// load Dojo theme variables
	// NOTE: Our React implementation currently uses portals, so placing the CSS variables on a local DOM node here
	// does not work. We would have to duplicate the theme on each portal (see ReactRoot). Instead, variables will
	// be applied to root DOM element. These will eventually be replaced by new design system.
	const themeVariables = csi.syncRequire("csi/skintheme/" + skin);
	if (themeVariables) {
		setCSSVariables(themeVariables);
	}

	const skinVariables = getSkinVariables(skin);
	if (skinVariables) {
		setCSSConstants(skinVariables);
	}

	return (
		// TODO: Link C8 and DS themes together
		<Theme skin={skin}>
			<DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
				<LocaleContext.Provider value={localeProvider}>
					<ReactPortals />
				</LocaleContext.Provider>
			</DndProvider>
		</Theme>
	);
});

export default ReactRoot;
